import ModalCatalog from './modal-catalog';

export default class ButtonModalCatalog {
    constructor(button) {
        this.button = button;
        this.modal = document.querySelector('.header-desktop__catalog-modal');
        this.close = document.querySelector('.header__overlay-catalog');
        this.categoryDepthLevelOne = document.querySelector('.header-desktop__catalog-left');
        this.modalCatalog = new ModalCatalog(this.categoryDepthLevelOne);
        this.closeTimeout = null;

        this.eventRegister();
    }

    openModal() {
        const modal = document.querySelector('.header-desktop__catalog-modal');
        if (!modal || !this.close) return;

        modal.style.display = 'block';
        this.close.style.display = 'block';
        this.modalCatalog.addRightContainer();
    }

    closeModal() {
        const modal = document.querySelector('.header-desktop__catalog-modal');
        if (!modal || !this.close) return;

        modal.style.display = 'none';
        this.close.style.display = 'none';

        document.dispatchEvent(new CustomEvent('closeModalCatalog'));
        this.modalCatalog.deleteRightContainer();
    }

    addHoverButton() {
        this.button.classList.add('btn-catalog--active');
    }
    deleteHoverButton() {
        this.button.classList.remove('btn-catalog--active');
    }
    eventRegister() {
        this.button.addEventListener('mouseenter', () => {
            this.openTimeout = setTimeout(() => {
                this.openModal();
                this.addHoverButton();
            }, 100);
        });
        this.button.addEventListener('mouseleave', () => {
            clearTimeout(this.openTimeout);
        });
        this.close.addEventListener('mouseenter', () => {
            this.closeTimeout = setTimeout(() => {
                this.closeModal();
                this.deleteHoverButton();
            }, 300);
        });
        this.close.addEventListener('mouseleave', () => {
            clearTimeout(this.closeTimeout);
        });
    }
}
